import $ from "jquery";

const MovePaginationNext = (el) => {
    let $el = $(el);
    var nextLi = $el.find("li:has(a.next)");
    var prevLi = $el.find("li:has(a.prev)");
    if (nextLi.length) {
        if (prevLi.length) {
            nextLi.insertAfter(prevLi);
        } else {
            $el.prepend(nextLi);
        }
    }
    $el.css("opacity", "1");
};

export default MovePaginationNext;
